import styled from "styled-components";
import { desktop, generic as sg } from "../../../../../ui/_themes/constants";
import { IDialogDesktop } from "../../Desktop/DialogDesktop";

export const Wrapper = styled.div`
  pointer-events: all;
  font-family: ${desktop.defaultFont};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${(props: IDialogDesktop) =>
    props.cover ? sg.dialogs.coverBackgroundColor : sg.dialogs.overlayColor};
  z-index: ${sg.layers.dialog};
  display: flex;
  justify-content: center;
  align-items: center;
`;
